// removed by extract-text-webpack-plugin
module.exports = {"bubble-nav":"bubble-slide__bubble-nav___1bANu","bubble-nav__prev":"bubble-slide__bubble-nav__prev___14_Sg","bubble-nav__next":"bubble-slide__bubble-nav__next___1oOwj"};


//////////////////
// WEBPACK FOOTER
// ./src/js/Components/Bubble-slide/bubble-slide.scss
// module id = 114
// module chunks = 0